// Login management
import Oidc from '@/js/services/oidc-client';
import appSettings from './appSettings';
// if ( process.env.NODE_ENV === 'development' ) {
// 	Oidc.Log.level = Oidc.Log.DEBUG;
// 	Oidc.Log.logger = console;
// }

let userManager = null;

let csSettings = undefined;

appSettings.get().then((settings) => {
	csSettings = settings;
});

export default {
	init() {
		let installUrl = window.location.protocol + '//' + window.location.hostname;

		if (window.location.port !== '' && window.location.port !== 0) {
			installUrl += ':' + window.location.port;
		}

		userManager = new Oidc.UserManager({
			authority: csSettings.VUE_APP_IDENTITY_BASE,
			client_id: "vue",
			redirect_uri: `${installUrl}/logincallback`,
			silent_redirect_uri: `${installUrl}/static/silentrenewcallback.html`,
			automaticSilentRenew : false,
			response_type: "code",
			scope: "openid profile email api1",
			post_logout_redirect_uri: `${installUrl}/account/logout?redirectUrl=${installUrl}`
		});
	},

	getUserManager() {
		if ( !userManager ) {
			this.init();
		}

		return userManager;
	}
}
